module.exports = __webpack_public_path__ + "img/03.e81a26a3.png";